import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow
} from 'components/table';
import GrowthTableRowWaiting from 'containers/pages/growthtracker/table/GrowthTableRowWaiting';

const GrowthTableWaiting = () => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell />
          {Array(3)
            .fill()
            .map((v, i) => (
              <TableHeaderCell key={i} />
            ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {Array(8)
          .fill()
          .map((row, i) => (
            <GrowthTableRowWaiting key={i} />
          ))}
      </TableBody>
    </Table>
  );
};

export default GrowthTableWaiting;
